import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaUserEdit,
  FaEnvelope,
  FaCalendarAlt,
  FaGraduationCap,
} from "react-icons/fa";
import "styles/profile.css";
import PanelLayout from "./PanelLayout";

const Profile = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const name = localStorage.getItem("userName");
    const role = (localStorage.getItem("userRole") || "guest").toLowerCase();

    if (!name || role === "guest") {
      navigate("/login");
      return;
    }

    const userData = {
      name: name || "Foydalanuvchi",
      role: role,
      email:
        localStorage.getItem("userEmail") ||
        `${name.toLowerCase().replace(/\s/g, ".")}@example.com`,
      joinedDate: localStorage.getItem("joinedDate") || "2024-09-01",
      studentClass:
        role === "student"
          ? localStorage.getItem("studentClass") || "9-'A'"
          : null,
      teacherSubject:
        role === "teacher"
          ? localStorage.getItem("teacherSubject") || "Matematika"
          : null,
      avatar: `https://i.pravatar.cc/150?u=${name}`,
    };

    setUser(userData);
    setLoading(false);
  }, [navigate]);

  if (loading) {
    return <div className="loading">Ma'lumotlar yuklanmoqda...</div>;
  }

  if (!user) {
    return <div className="error">Profil ma'lumotlari topilmadi</div>;
  }

  return (
    <PanelLayout>
      <div className="profile-container">
        <div className="profile-header">
          <img
            src={user.avatar}
            alt="Profil rasmi"
            className="profile-avatar-large"
          />
          <div className="profile-title">
            <h1>{user.name}</h1>
            <div className={`role-badge ${user.role}`}>
              {user.role === "admin"
                ? "Administrator"
                : user.role === "teacher"
                ? "O'qituvchi"
                : "O'quvchi"}
            </div>
          </div>
        </div>

        <div className="profile-info-cards">
          <div className="info-card">
            <h3>Umumiy ma'lumotlar</h3>
            <div className="info-row">
              <FaEnvelope className="icon" />
              <div>
                <span className="label">Email</span>
                <p>{user.email}</p>
              </div>
            </div>
            <div className="info-row">
              <FaCalendarAlt className="icon" />
              <div>
                <span className="label">Tizimda qayd bo'lgan sana</span>
                <p>{new Date(user.joinedDate).toLocaleDateString("uz-UZ")}</p>
              </div>
            </div>
          </div>

          {user.role === "student" && (
            <div className="info-card student-card">
              <h3>O'quvchi ma'lumotlari</h3>
              <div className="info-row">
                <FaGraduationCap className="icon" />
                <div>
                  <span className="label">Sinf</span>
                  <p>{user.studentClass}</p>
                </div>
              </div>
            </div>
          )}

          {user.role === "teacher" && (
            <div className="info-card teacher-card">
              <h3>O'qituvchi ma'lumotlari</h3>
              <div className="info-row">
                <FaGraduationCap className="icon" />
                <div>
                  <span className="label">Fan</span>
                  <p>{user.teacherSubject}</p>
                </div>
              </div>
            </div>
          )}

          {user.role === "admin" && (
            <div className="info-card admin-card">
              <h3>Administrator huquqlari</h3>
              <ul className="admin-privileges">
                <li>Barcha foydalanuvchilarni boshqarish</li>
                <li>Tizim sozlamalari</li>
                <li>Statistik ma'lumotlar</li>
                <li>Hisobotlar yaratish</li>
              </ul>
            </div>
          )}
        </div>

        <div className="profile-actions">
          <button className="btn btn-primary">
            <FaUserEdit /> Ma'lumotlarni tahrirlash
          </button>
        </div>
      </div>
    </PanelLayout>
  );
};

export default Profile;
